<template>
  <div>
    <!--for other content-->
    <Services />
  </div>
</template>

<script>
//import { getManualPicks, removeManualPicks } from '@/utils/api';
import Services from '@/components/admin/Services';

export default {
  components: {
    Services
  },
  methods: {
    addNewService: function () {
      this.picks.push({
        id: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
        dateTime: new Date(),

      })
    }
  }
}
</script>

<style scoped>

</style>